export default {
    getList: async function (params) {
        let option = {
            url: '/api/v1/awr_analyze/overview',
            type: 'get',
            params: params,
            mock: {
                state: false,
                data: this.$mock.userAwrUnscramble.getList.default,
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    doAnalyze: async function (params) {
        let option = {
            url: '/api/v1/awr_analyze/analyze',
            type: 'post',
            params: params,
            mock: {
                state: false,
                data: this.$mock.userAwrUnscramble.getList.default,
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    postAwrReport: async function (params) {
        let option = {
            url: '/api/v1/awr_analyze/html_report',
            type: 'postFile',
            params: params,
            mock: {
                state: false,
                data: this.$mock.userAwrUnscramble.getList.default,
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    getReport: {
        html: async function(params) {
            let option = {
                url: '/api/v1/awr_analyze/html_report',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: "",
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        report: async function(params) {
            let option = {
                url: '/api/v1/awr_analyze/analyze',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: "",
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    },
    getFile: async function(params){
        let option = {
            url: params.url,
            type: 'file',
            params: params,
            mock: {
                state: false,
                data: "",
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
}